<script lang="ts" context="module">

    import { GameTypeService } from "../../Services/GameTypeService";
    import type { GameType } from "../../global";

    const imagesMap = new Map<GameType, Promise<HTMLImageElement>>();

    function getImage(gameType: GameType): Promise<HTMLImageElement> {
        if (!imagesMap.has(gameType)) {
            const cardImage = GameTypeService.getCardImage(gameType);
            if (!cardImage) {
                throw new Error(`No card image found for game type: ${gameType}`);
            }
            
            const promise = new Promise<HTMLImageElement>(resolve => {
                const image = document.createElement('img') as HTMLImageElement;
                image.addEventListener('load', () => resolve(image), { once: true });
                image.src = cardImage;
            });
            imagesMap.set(gameType, promise);
        }
        return imagesMap.get(gameType);
    }

</script>
<script lang="ts">
    
    import { onMount } from "svelte";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";

    export let number: number;
    export let gameType: GameType;

    const width = 321;
    const height = 512;

    let canvas: HTMLCanvasElement;
    let ctx: CanvasRenderingContext2D;

    $: updateBackgroundPostion(ctx, number);

    onMount(() => {
        ctx = canvas.getContext('2d');
    });

    async function updateBackgroundPostion(ctx: CanvasRenderingContext2D, number: number): Promise<void> {
        if (!ctx) {
            return;
        }

        const cardIndex = number - 1;
        const image = await getImage(gameType);
        const numberWidth = GameTypeService.getNumberWidth(gameType);
        const numberHeigth = GameTypeService.getNumberHeight(gameType);
        const x = cardIndex % numberWidth;
        const y = Math.floor(cardIndex / numberWidth);
        const w = image.naturalWidth / numberWidth;
        const h = image.naturalHeight / numberHeigth;
        const ox = w * x;
        const oy = h * y;
        ctx.drawImage(image, ox, oy, w, h, 0, 0, width, height);
    }

</script>

<AspectKeeper ratio={height / width}>
    <canvas bind:this={canvas} {width} {height}></canvas>
</AspectKeeper>

<style lang="scss">

    canvas {
        width: 100%;
        height: 100%;
    }

</style>
